export default __webpack_public_path__ + "static/media/filter.042e5065.png";